export default "__VITE_ASSET__BYPRpm_0__"